import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { GamePadModel } from '../../../Models/Game/GamePadModel';

export interface IGamePadJoystickControllerOptions {
}

export class GamePadJoystickController extends AnimationBaseController {
    $model: GamePadModel;
    private _pointerDown: boolean = false;
    private _pointerOver: boolean = false;
    private _pressed: boolean = false;
    private _enabled: boolean = true;

    public constructor(@Inject private _options: IGamePadJoystickControllerOptions,
                       @Inject private _gameLogic: GameLogic) {
        super('GamePadJoystickController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            childControllers: {},
            modelWatch: {},
            onPointerDown: () => {
                if (!this._enabled) {
                    return;
                }
                this._pointerDown = true;
                //this.gotoAndStop("down");
            },
            onPointerOut: () => {
                if (!this._enabled) {
                    return;
                }
                if (!this._pointerDown) {
                    //this.gotoAndStop(this.selected ? "down" : "up");
                }
                this._pointerOver = false;
            },
            onPointerOver: () => {
                if (!this._enabled) {
                    return;
                }
                if (this._pointerDown) {
                    //this.gotoAndStop("down");
                } else {
                    //this.gotoAndStop(this.selected ? "down" : "over");
                }
                this._pointerOver = true;
            },
            onPointerUp: () => {
                if (!this._enabled) {
                    return;
                }
                this._pointerDown = false;
                this.setPosByQuery('stick', 0, 0);
                this._gameLogic.unitMoveStop([1, 1]);
                if (this._pointerOver) {
                    //this.gotoAndStop(this.selected ? "down" : "over");
                } else {
                    //this.gotoAndStop(this.selected ? "down" : "up");
                }
                //this.soundManager.play(SoundConstants.BUTTON_CLICK);
            },
            onPointerUpOutside: () => {
                if (!this._enabled) {
                    return;
                }
                //this.gotoAndStop(this.selected ? "down" : "up");
                this._pointerDown = false;
                this.setPosByQuery('stick', 0, 0);
                this._gameLogic.unitMoveStop([1, 1]);
            },
            onPointerMove: e => {
                if (!this._pointerDown) {
                    return;
                }

                let x = e.screenPosition.x;
                let y = e.screenPosition.y;
                let length = Math.sqrt(x * x + y * y);
                let n: [number, number] = [x / length, y / length];

                this._gameLogic.unitMoveStart(n);

                this.setPosByQuery('stick', e.screenPosition.x, e.screenPosition.y);
            },
        };
    }

    protected onInitialize(): void {

    }

    protected onResize(width: number, height: number, scale: number): void {
        this.y = 0;
        this.x = -width / scale / 2 + 200;
    }
}

